/**
 * API functions for document operations
 */

import { auth } from "@/lib/firebase"

/**
 * Updates a document's relevancy status
 */
export const updateDocumentRelevancy = async (
	caseId: string,
	documentId: string,
	isRelevant: boolean,
	reason?: string
): Promise<{ message: string }> => {
	const apiUrl = `${
		import.meta.env.VITE_API_URL
	}/api/cases/${caseId}/documents/${documentId}/relevancy`

	const user = auth.currentUser
	if (!user) {
		throw new Error("User not found.")
	}
	const token = await user.getIdToken()
	const response = await fetch(apiUrl, {
		method: "PUT",
		headers: {
			"Content-Type": "application/json",
			Authorization: `Bearer ${token}`,
		},
		body: JSON.stringify({
			is_relevant: isRelevant,
			reason: reason || null,
		}),
	})

	if (!response.ok) {
		const errorData = await response.text()
		throw new Error(
			`Failed to update document relevancy: ${response.status} ${response.statusText} - ${errorData}`
		)
	}

	return await response.json()
}
